module.exports = __webpack_public_path__ + "static/media/ethernal_fire.61fdc151.png";